<template>
  <div class="Cart">
    <div class="title">购物车</div>
    <div v-if="orderList.length > 0">
      <div class="cartTableHeader">
        <span>
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          ></el-checkbox>
        </span>
        <span>商品信息</span>
        <span>单价</span>
        <span>单位</span>
        <span>数量</span>
        <!-- <span>小计</span> -->
        <span>操作</span>
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <div class="orderDetail">
            <el-checkbox
              v-model="item.checked"
              @change="handleCheckedChange"
            ></el-checkbox>
            <img
              :src="
                item['gdlu2l0z6a7sprky'] && item['gdlu2l0z6a7sprky'].length > 0
                  ? item['gdlu2l0z6a7sprky'][0].url
                  : ''
              "
              alt="商品图片"
            />
            <div class="goodsName">
              <p
                @click="navTo('/mall/goods/' + item.duovdnoapszqxeih[0].id)"
                v-if="item.duovdnoapszqxeih && item.duovdnoapszqxeih.length > 0"
              >
                {{ item.duovdnoapszqxeih[0].value }}
              </p>
              <!-- <span>{{ item.goods.spec }}</span> -->
            </div>
            <span class="unitPrice">
              {{ item.qajsmihzqxevgihj ? '￥' + item.qajsmihzqxevgihj : 0 }}
            </span>
            <span class="unitPrice">
              {{ item.ycqgzdztcyhqnczy }}
            </span>
            <span class="num">
              <NumberInput
                @changeHandle="numberChange(item)"
                :initNum="item.tbdn8rpen3ijbiv2"
                v-model="item.tbdn8rpen3ijbiv2"
                :min="1"
                :max="99999"
              />
            </span>
            <!-- <input @change="numberChange(item.id)" type="text" v-model="item.temGoodsNum" min="1" class="numInput" /> -->
            <!-- <span class="amount">{{ "￥" + item.amount }}</span> -->
            <!-- <button @click="deleteOrder(item.id)">
             删除
            </button> -->
            <span @click="deleteOrder(item.id)">
              <img src="../../assets/img/del.svg" alt="" class="icon" />
            </span>
          </div>
        </li>
      </ul>
      <div class="cartFooter">
        <!-- <span>应付金额：</span> -->
        <!-- <span class="total">{{ '￥' + totalAmount }}</span> -->
        <button @click="settleAccounts">下单</button>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/cart.svg" alt="" />
    </p>
  </div>
</template>

<script>
// import { mapState } from "vuex";
import NumberInput from "../../components/NumberInput";
import {
  online,
  delOnline,
  updateOnline,
  buttons,
} from "@/api/platform";
export default {
  name: "Cart",
  components: {
    NumberInput,
  },
  computed: {
    totalAmount () {
      let amount = 0;
      this.orderList.map((item, index) => {
        amount += item.tbdn8rpen3ijbiv2 * item.qajsmihzqxevgihj;
      });
      return amount;
    },
  },
  data () {
    return {
      form_head_uuid: "a6cf518450fb43289af179b8beb4b943",
      order: {},
      orderList: [],
      checkAll: false,
      isIndeterminate: false,
    };
  },
  created () {
    this.$store.dispatch('getCartQuantity');
  },

  methods: {
    // 全选
    handleCheckAllChange () {
      this.orderList = this.orderList.map((item) => {
        return {
          ...item,
          checked: this.checkAll,
        };
      });
      if (this.checkAll) this.isIndeterminate = false;
    },
    // 单选
    handleCheckedChange () {
      const checkedItemsCount = this.orderList.filter(
        (item) => item.checked
      ).length;
      const isAllChecked = checkedItemsCount === this.orderList.length;
      this.isIndeterminate = checkedItemsCount > 0 && !isAllChecked;
      this.checkAll = isAllChecked;
    },
    // 获取购物车列表
    async getShoppingCartList () {
      const { form_head_uuid } = this;
      const { result } = await online({
        page: 1,
        limit: 100,
        keyword: "",
        select_option: "",
        form_head_uuid,
      });
      if (result.length > 0) {
        this.orderList = result.map(el => {
          return {
            ...el,
            checked: false,
          }
        });
      } else {
        this.orderList = []
      }
    },
    async numberChange (item) {
      const { form_head_uuid } = this;
      const { id } = item
      await updateOnline({
        id,
        form_head_uuid,
        tbdn8rpen3ijbiv2: item.tbdn8rpen3ijbiv2
      });
      this.$store.dispatch('getCartQuantity');
    },
    async deleteOrder (orderId) {
      const { form_head_uuid } = this;
      await delOnline({
        form_head_uuid,
        ids: [orderId],
      });
      this.getShoppingCartList();
      this.$store.dispatch('getCartQuantity');
    },
    navTo (route) {
      this.$router.push(route);
    },
    async settleAccounts () {
      let commodityList = this.orderList.filter(el => el.checked)
      if (commodityList && commodityList.length > 0) {
        this.$store.commit('setData', {
          commodityList,
        });
        this.$router.push('/mall/createOrder?form=cart')
      } else {
        return this.$notify.error({
          title: '提示',
          message: '您还没有选择商品'
        });
      }
    },
  },

  mounted () {
    this.getShoppingCartList();
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.Cart {
  width: 100%;
  height: 100%;
  background: #fff;
  display: block;
  padding: 30px 0;
  .title {
    height: 18px;
    font-size: 18px;
    color: #333333;
    margin-bottom: 20px;
    border-left: 4px solid #de531d;
    padding-left: 10px;
    line-height: 18px;
  }
  .emptyTips {
    // width: 200px;
    text-align: center;
    margin: 200px auto;
  }
  .cartTableHeader {
    width: 100%;
    height: 40px;
    background-color: #fafafa;
    border: 1px solid @borderColor;
    color: #666;
    font-size: 14px;
    line-height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      display: inline-block;
      width: 160px;
      text-align: center;
      line-height: 40px;
      flex-shrink: 0;
      &:first-child {
        width: 50px;
        flex-shrink: 0;
        text-align: center;
      }
      &:nth-child(2) {
        width: 508px;
      }
    }
  }
  .orderList {
    width: 100%;
    li {
      border: 1px solid @borderColor;
      border-top: none;
      font-size: 13px;
      .orderHeader {
        background-color: #f1f1f1;
        height: 40px;
        line-height: 40px;
        padding: 0 5px;
        .orderTime {
          font-weight: 600;
        }
        .orderId,
        .state {
          margin-left: 10px;
        }
      }
      .orderDetail {
        width: 100%;
        height: 100%;
        padding: 20px 0;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666;
        .el-checkbox {
          width: 60px;
          text-align: center;
        }
        img {
          width: 80px;
          height: 80px;
          display: inline-block;
        }
        .goodsName {
          width: 476px;
          vertical-align: top;
          height: 84px;
          font-size: 14px;
          padding-left: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          span {
            color: @fontDefaultColor;
            display: block;
            margin-top: 10px;
          }
        }
        .unitPrice,
        .num,
        .amount {
          flex-shrink: 0;
          display: inline-block;
          vertical-align: top;
          width: 160px;
          height: 85px;
          line-height: 85px;
          text-align: center;
          display: flex;
          justify-content: center;
        }
        .NumberInput {
          position: relative;
          top: 25px;
          /deep/span {
            color: #666;
          }
        }
        button {
          position: absolute;
          right: 20px;
          bottom: 40px;
          width: 70px;
          height: 30px;
          border-radius: 3px;
          background-color: @falseColor;
          color: white;
          border: none;
        }
        span {
          cursor: pointer;
          &:last-child {
            width: 180px;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
  }
  .cartFooter {
    width: 100%;
    height: 70px;
    line-height: 70px;
    padding: 0 10px;
    border: 1px solid @borderColor;
    border-top: none;
    background-color: #fafafa;
    position: relative;
    span {
      color: @fontDefaultColor;
      display: inline-block;
      vertical-align: top;
    }
    .total {
      color: @falseColor;
      font-size: 25px;
      font-weight: 600;
    }
    button {
      position: absolute;
      right: 0;
      top: 0;
      width: 150px;
      height: 100%;
      background-color: @thirdColor;
      border: none;
      color: white;
      font-size: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Cart.vue